<template>
  <div>
    <header>
      <div class="pillar">
        <div id="navToggle">
          <i class="fas fa-bars"></i>
        </div>

        <router-link :to="{name: 'Homepage'}" class="logo">
          <img src="@/assets/images/umoney_logo.png">
        </router-link>

        <div class="header__menu" v-if="topmenus">
          <template v-for="topmenu in topmenus">
            <div
              v-if="topmenu.contents && topmenu.childEntries.rows.length > 0"
              :key="topmenu.id"
              class="topmenu"
              @mouseenter="expandHeader"
              @mouseleave="shrinkHeader()"
            >
              <div
                @click="headerLink($event, topmenu.childEntries.rows[0].url)"
                class="topmenu__name"
              >{{ topmenu.contents[0].title }}</div>

              <ul class="topmenu__list">
                <template v-for="submenu in topmenu.childEntries.rows">
                  <li
                    v-if="submenu.contents"
                    :key="submenu.id"
                    @click="headerLink($event, submenu.url)"
                    class="submenu"
                  >{{ submenu.contents[0].title }}</li>
                </template>
              </ul>
            </div>
          </template>
        </div>

        <div class="d-flex">
          <div
            :class="[{ 'lang--active' : language === 'lang-mon' }, 'lang']"
            @click="toggleLanguage('lang-mon')"
          >MN</div>
          <div
            :class="[{ 'lang--active' : language === 'lang-eng' }, 'lang']"
            @click="toggleLanguage('lang-eng')"
          >EN</div>

          <div v-if="isAuth()" class="d-flex ml-2 pl-2">
            <div class="dropdown dropdown-right">
              <a class="btn btn-link icon-user dropdown-toggle" tabindex="0">
                <i class="fas fa-user"></i>
              </a>
              <ul class="menu text-right">
                <li class="menu-item">
                  <router-link
                    to="/m/card-register"
                  >{{ this.getCaption('caption.check_card_number') }}</router-link>
                </li>
                <li class="menu-item">
                  <router-link
                    :to="{name: 'UpdateUser'}"
                  >{{ this.getCaption('caption.change_information') }}</router-link>
                </li>
                <li class="menu-item">
                  <router-link
                    :to="{name: 'ChangePassword'}"
                  >{{ this.getCaption('caption.change_password') }}</router-link>
                </li>
                <li class="menu-item">
                  <router-link :to="{name: 'Logout'}">{{ this.getCaption('caption.logout_button') }}</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div v-else class="ml-2 pl-2 d-flex">
            <router-link class="btn btn-link icon-user" :to="{name: 'SignIn'}">
              <i class="fas fa-user"></i>
            </router-link>
          </div>
        </div>
      </div>
    </header>
    <div id="dropdown__bg"></div>
  </div>
</template>


<script>
import UserService from "@/services/UserService.js";

export default {
  computed: {
    topmenus() {
      return this.$store.state.topmenus;
    },

    language() {
      return window.localStorage.getItem("language");
    }
  },

  mounted() {
    this.toggleSidenav();
  },

  methods: {
    expandHeader(event) {
      let header = document.getElementsByTagName("header")[0];
      let topmenu = event.target;

      let topmenuList = topmenu.childNodes[1];
      let offsetDiff, offsetLeft;
      if (topmenu.offsetWidth > topmenuList.offsetWidth) {
        offsetDiff = topmenu.offsetWidth - topmenuList.offsetWidth;
        offsetLeft = topmenu.offsetLeft + offsetDiff / 2;
      } else if (topmenu.offsetWidth < topmenuList.offsetWidth) {
        offsetDiff = topmenuList.offsetWidth - topmenu.offsetWidth;
        offsetLeft = topmenu.offsetLeft - offsetDiff / 2;
      }
      topmenuList.style.left = offsetLeft + "px";

      let submenuCount = topmenu.childNodes[1].childElementCount;
      let dropdownBgHeight = 35 * submenuCount + 30;

      header.classList.add("desktop-fill");
      document.getElementById("dropdown__bg").style.height =
        dropdownBgHeight + "px";
      document.getElementById("dropdown__bg").style.display = "block";

      topmenu.childNodes[1].style.visibility = "visible";
    },

    shrinkHeader(submenuList) {
      let header = document.getElementsByTagName("header")[0];
      header.classList.remove("desktop-fill");
      document.getElementById("dropdown__bg").style.height = "0";
      document.getElementById("dropdown__bg").style.display = "none";
      if (submenuList) {
        submenuList.style.visibility = "hidden";
      }
    },

    headerLink(event, url) {
      this.$router.push(url);
      if (event.target.parentNode.nodeName == "DIV") {
        this.shrinkHeader(event.target.parentNode.childNodes[1]);
      } else {
        this.shrinkHeader(event.target.parentNode);
      }
    },

    toggleSidenav() {
      let sideNav = document.getElementById("sidenav");

      document
        .getElementById("navToggle")
        .addEventListener("click", function() {
          sideNav.classList.toggle("hidden");
          document
            .getElementsByTagName("header")[0]
            .classList.toggle("mobile-fill");
        });
    },

    toggleLanguage(lang) {
      let currentLanguage = window.localStorage.getItem("language");
      if (lang === currentLanguage) return;
      let otherLanguage = lang;

      if (this.isAuth()) {
        UserService.toggleLanguage({
          headers: {
            "x-umoney-language": otherLanguage
          }
        }).then(response => {
          if (response.data.success) {
            window.localStorage.setItem("language", otherLanguage);
            location.reload(true);
          }
        });
      } else {
        window.localStorage.setItem("language", otherLanguage);
        location.reload(true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
a.btn.btn-link.icon-user {
  border: 1px solid #3b4351;
  border-radius: 50%;
  padding: 4px 10px;
  -webkit-border-radius: 50%;
}
a.btn.btn-link.icon-user i {
  color: #3b4351;
}

.splash a.btn.btn-link.icon-user {
  border-color: #fff;
}
.splash a.btn.btn-link.icon-user i {
  color: #fff;
}

a.btn.btn-link.icon-user:hover {
  border-color: $orange-color;
}
a.btn.btn-link.icon-user:hover i {
  color: $orange-color;
}

.menu {
  width: auto;

  .menu-item {
    white-space: nowrap;
  }
}
.menu .menu-item > a:focus,
.menu .menu-item > a:hover {
  color: $orange-color;
}
</style>
